import { render, staticRenderFns } from "./AppStoreNavigation.vue?vue&type=template&id=b0d3362e&scoped=true"
import script from "./AppStoreNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreNavigation.vue?vue&type=style&index=0&id=b0d3362e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d3362e",
  null
  
)

export default component.exports